import * as config from './config.json';
import { buildPost } from './genericMethods';

export const trackActionClicked = (action: string, additionalInfo = '') => {
  const additionalInfoParam = additionalInfo ? `&additionalInformation=${additionalInfo}` : '';
  const url = `${config.ANALYTICS}?functionality=${action}${additionalInfoParam}`;
  return buildPost(url, {});
};
